// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__mQLmz","title":"Home_title__1aNQh","text":"Home_text__bwQM6"};